import { BetTypeKey } from '../../models/bet-type.model';
import { Sport } from '../../models/sport.model';
import { MatchDetailTabId, MatchDetailTabViewModel } from '../sportsbook.models';
import {
  MatchDetailSectionFamilyDefinition,
  MatchDetailTabDefinition,
  MatchDetailTabsLabelResolver
} from './sportsbook-config.types';

const BET_PREVIEW_ACCORDION_GROUPS = {
  top: [
    BetTypeKey.WAY_3,
    BetTypeKey.WAY_3_XUP,
    BetTypeKey.NEXT_GOAL,
    BetTypeKey.REST_OF_MATCH,
    BetTypeKey.WAY_2,
    BetTypeKey.WAY_3_OT,
    BetTypeKey.NEXT_GOAL_OT,
    BetTypeKey.REST_OF_MATCH_OT,
    BetTypeKey.UNDER_OVER_OT,
    BetTypeKey.GOAL_NOGOAL,
    BetTypeKey.DOUBLE_CHANCE,
    BetTypeKey.ADVANCE_NEXT_ROUND,
    BetTypeKey.WAY_3_H1,
    BetTypeKey.NEXT_GOAL_H1,
    BetTypeKey.REST_OF_MATCH_H1,
    BetTypeKey.UNDER_OVER,
    BetTypeKey.UNDER_OVER_H1,
    BetTypeKey.HANDICAP,
    BetTypeKey.MULTISCORES,
    BetTypeKey.WAY_3_INT_10,
    BetTypeKey.PENALTY_SHOOTOUT,
    BetTypeKey.DNB,
    BetTypeKey.WIN_TO_NIL_HOMETEAM,
    BetTypeKey.WIN_TO_NIL_AWAYTEAM,
    BetTypeKey.WIN_EITHER_HALF_HOMETEAM,
    BetTypeKey.WIN_EITHER_HALF_AWAYTEAM
  ],
  handicap: [BetTypeKey.HANDICAP, BetTypeKey.HANDICAP_H1, BetTypeKey.HANDICAP_H2],
  half: [
    BetTypeKey.UNDER_OVER_H1,
    BetTypeKey.NEXT_GOAL_H1,
    BetTypeKey.WAY_3_H1,
    BetTypeKey.REST_OF_MATCH_H1,
    BetTypeKey.GOAL_NOGOAL_H1,
    BetTypeKey.HANDICAP_H1,
    BetTypeKey.DOUBLE_CHANCE_H1,
    BetTypeKey.TOTAL_GOALS_EXACT_H1,
    BetTypeKey.CORRECT_SCORE_H1,
    BetTypeKey.CORRECT_SCORE_LIVE_H1,
    BetTypeKey.UNDER_OVER_H2,
    BetTypeKey.WAY_3_H2,
    BetTypeKey.GOAL_NOGOAL_H2,
    BetTypeKey.HANDICAP_H2,
    BetTypeKey.DOUBLE_CHANCE_H2,
    BetTypeKey.TOTAL_GOALS_EXACT_H2,
    BetTypeKey.HT_FT,
    BetTypeKey.HIGHEST_SCORE_HALF,
    BetTypeKey.PERIOD_WINNER,
    BetTypeKey.UNDER_OVER_PERIOD,
    BetTypeKey.XTH_GOAL_PERIOD,
    BetTypeKey.REST_OF_MATCH_PERIOD,
    BetTypeKey.HIGHEST_SCORE_PERIOD,
    BetTypeKey.UNDER_OVER_CORNER_H1,
    BetTypeKey.UNDER_OVER_HOMETEAM_H1,
    BetTypeKey.UNDER_OVER_AWAYTEAM_H1,
    BetTypeKey.WAY_3_UNDER_OVER_H1,
    BetTypeKey.WAY_3_UNDER_OVER_H2,
    BetTypeKey.WAY_3_GOAL_NOGOAL_H1,
    BetTypeKey.WAY_3_GNG_H2,
    BetTypeKey.WAY_3_OR_WAY_3_H1
  ],
  overUnder: [
    BetTypeKey.UNDER_OVER,
    BetTypeKey.UNDER_OVER_H1,
    BetTypeKey.UNDER_OVER_H2,
    BetTypeKey.UNDER_OVER_OT,
    BetTypeKey.WAY_3_UNDER_OVER,
    BetTypeKey.UNDER_OVER_AWAYTEAM,
    BetTypeKey.UNDER_OVER_HOMETEAM,
    BetTypeKey.UNDER_OVER_GOAL_NOGOAL,
    BetTypeKey.UNDER_OVER_CORNER,
    BetTypeKey.UNDER_OVER_CORNER_HOMETEAM,
    BetTypeKey.UNDER_OVER_CORNER_AWAYTEAM,
    BetTypeKey.UNDER_OVER_CORNER_H1,
    BetTypeKey.UNDER_OVER_HOMETEAM_H1,
    BetTypeKey.UNDER_OVER_AWAYTEAM_H1,
    BetTypeKey.WAY_3_UNDER_OVER_H1,
    BetTypeKey.WAY_3_UNDER_OVER_H2,
    BetTypeKey.DOUBLE_CHANCE_UNDER_OVER,
    BetTypeKey.UNDER_OVER_PERIOD
  ],
  goalNoGoal: [
    BetTypeKey.GOAL_NOGOAL,
    BetTypeKey.GOAL_NOGOAL_H1,
    BetTypeKey.GOAL_NOGOAL_H2,
    BetTypeKey.WAY_3_GOAL_NOGOAL,
    BetTypeKey.UNDER_OVER_GOAL_NOGOAL,
    BetTypeKey.WAY_3_GOAL_NOGOAL_H1,
    BetTypeKey.WAY_3_GNG_H2,
    BetTypeKey.DOUBLE_CHANCE_GOAL_NOGOAL
  ],
  goals: [
    BetTypeKey.TOTAL_GOALS,
    BetTypeKey.TOTAL_GOALS_EXACT,
    BetTypeKey.TOTAL_GOALS_EXACT_H1,
    BetTypeKey.TOTAL_GOALS_EXACT_H2,
    BetTypeKey.GOAL_AWAYTEAM,
    BetTypeKey.GOAL_HOMETEAM,
    BetTypeKey.LAST_GOAL,
    BetTypeKey.FIRST_GOAL_INT_15,
    BetTypeKey.HIGHEST_SCORE_HALF,
    BetTypeKey.XTH_GOAL_PERIOD,
    BetTypeKey.GNG_BOTH_HALVES_HOMETEAM,
    BetTypeKey.GNG_BOTH_HALVES_AWAYTEAM,
    BetTypeKey.XTH_GOAL_WAY3,
    BetTypeKey.ANYTIME_GOALSCORER
  ],
  results: [
    BetTypeKey.MULTISCORES,
    BetTypeKey.OUTRIGHT_WINNER,
    BetTypeKey.PERIOD_WINNER,
    BetTypeKey.CORRECT_SCORE,
    BetTypeKey.CORRECT_SCORE_LIVE,
    BetTypeKey.CORRECT_SCORE_H1,
    BetTypeKey.CORRECT_SCORE_LIVE_H1
  ],
  misc: [
    BetTypeKey.CORNER_WAY3,
    BetTypeKey.CORNER_TOTAL,
    BetTypeKey.PLAYER_SENT_OFF,
    BetTypeKey.UNDER_OVER_CORNER_HOMETEAM,
    BetTypeKey.UNDER_OVER_CORNER_AWAYTEAM,
    BetTypeKey.UNDER_OVER_CORNER_H1,
    BetTypeKey.MULTISCORES,
    BetTypeKey.WAY_3_OR_WAY_3_H1,
    BetTypeKey.WAY_3_XUP,
    BetTypeKey.ANYTIME_GOALSCORER
  ]
} as const satisfies Record<string, readonly BetTypeKey[]>;

export const MATCH_DETAIL_TAB_DEFINITIONS: readonly MatchDetailTabDefinition[] = [
  { id: 'top', label: 'Top', labelKey: 'sportsbook.tabs.top', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.top },
  { id: 'handicap', label: 'Handicap', labelKey: 'sportsbook.tabs.handicap', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.handicap },
  { id: 'halftime', label: 'Halftime', labelKey: 'sportsbook.tabs.halftime', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.half },
  { id: 'over-under', label: 'Over/Under', labelKey: 'sportsbook.tabs.overUnder', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.overUnder },
  { id: 'both-score', label: 'Both score', labelKey: 'sportsbook.tabs.bothScore', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.goalNoGoal },
  { id: 'goals', label: 'Goals', labelKey: 'sportsbook.tabs.goals', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.goals },
  { id: 'results', label: 'Results', labelKey: 'sportsbook.tabs.results', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.results },
  { id: 'misc', label: 'Other', labelKey: 'sportsbook.tabs.misc', candidateBetTypeKeys: BET_PREVIEW_ACCORDION_GROUPS.misc }
];

// These definitions provide ordering, labels and layout for individual BetTypes.
// Tabs own market grouping; every BetTypeKey must belong to exactly one definition here.
export const MATCH_DETAIL_SECTION_FAMILIES: readonly MatchDetailSectionFamilyDefinition[] = [
  {
    id: 'set-markets',
    title: 'Set Markets',
    titleKey: 'sportsbook.sections.setMarkets',
    candidateBetTypeKeys: [
      BetTypeKey.TENNIS_SET_WINNER,
      BetTypeKey.TENNIS_GAMES_WINNER,
      BetTypeKey.TENNIS_RESULTS_BEST3,
      BetTypeKey.TENNIS_RESULTS_BEST5,
      BetTypeKey.TENNIS_SETS_COUNT_3,
      BetTypeKey.TENNIS_SETS_COUNT_5,
      BetTypeKey.TENNIS_GAME_X_WINNER,
      BetTypeKey.TENNIS_SET_UNDER_OVER,
      BetTypeKey.TENNIS_SET_CORRECT_SCORE
    ],
    layout: 'list',
    defaultExpanded: false
  },
  {
    id: 'match-result',
    title: 'Match Result',
    titleKey: 'sportsbook.sections.matchResult',
    candidateBetTypeKeys: [BetTypeKey.WAY_3, BetTypeKey.WAY_3_OT, BetTypeKey.WAY_2, BetTypeKey.TENNIS_MATCH_WINNER],
    layout: 'grid3',
    defaultExpanded: true
  },
  {
    id: 'top-specials',
    title: 'Top Specials',
    titleKey: 'sportsbook.sections.topSpecials',
    candidateBetTypeKeys: [
      BetTypeKey.NEXT_GOAL,
      BetTypeKey.NEXT_GOAL_OT,
      BetTypeKey.NEXT_GOAL_H1,
      BetTypeKey.REST_OF_MATCH,
      BetTypeKey.REST_OF_MATCH_OT,
      BetTypeKey.REST_OF_MATCH_H1,
      BetTypeKey.ADVANCE_NEXT_ROUND,
      BetTypeKey.PENALTY_SHOOTOUT,
      BetTypeKey.WAY_3_INT_10,
      BetTypeKey.WIN_TO_NIL_HOMETEAM,
      BetTypeKey.WIN_TO_NIL_AWAYTEAM,
      BetTypeKey.WIN_EITHER_HALF_HOMETEAM,
      BetTypeKey.WIN_EITHER_HALF_AWAYTEAM
    ],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'total-goals',
    title: 'Total Goals (Over/Under)',
    titleKey: 'sportsbook.sections.totalGoals',
    candidateBetTypeKeys: [
      BetTypeKey.UNDER_OVER,
      BetTypeKey.UNDER_OVER_OT,
      BetTypeKey.TENNIS_UNDER_OVER,
      BetTypeKey.UNDER_OVER_HOMETEAM,
      BetTypeKey.UNDER_OVER_AWAYTEAM,
      BetTypeKey.UNDER_OVER_HOMETEAM_H1,
      BetTypeKey.UNDER_OVER_AWAYTEAM_H1,
      BetTypeKey.UNDER_OVER_GOAL_NOGOAL,
      BetTypeKey.WAY_3_UNDER_OVER,
      BetTypeKey.WAY_3_UNDER_OVER_H1,
      BetTypeKey.WAY_3_UNDER_OVER_H2,
      BetTypeKey.DOUBLE_CHANCE_UNDER_OVER
    ],
    layout: 'grid2',
    defaultExpanded: true
  },
  {
    id: 'double-chance',
    title: 'Double Chance',
    titleKey: 'sportsbook.sections.doubleChance',
    candidateBetTypeKeys: [BetTypeKey.DOUBLE_CHANCE],
    layout: 'grid3',
    defaultExpanded: true
  },
  {
    id: 'both-teams-to-score',
    title: 'Both Teams To Score',
    titleKey: 'sportsbook.sections.bothTeamsToScore',
    candidateBetTypeKeys: [
      BetTypeKey.GOAL_NOGOAL,
      BetTypeKey.WAY_3_GOAL_NOGOAL,
      BetTypeKey.WAY_3_GOAL_NOGOAL_H1,
      BetTypeKey.WAY_3_GNG_H2,
      BetTypeKey.DOUBLE_CHANCE_GOAL_NOGOAL
    ],
    layout: 'grid2',
    defaultExpanded: false
  },
  {
    id: 'correct-score',
    title: 'Correct Score',
    titleKey: 'sportsbook.sections.correctScore',
    candidateBetTypeKeys: [
      BetTypeKey.CORRECT_SCORE,
      BetTypeKey.CORRECT_SCORE_LIVE,
      BetTypeKey.CORRECT_SCORE_H1,
      BetTypeKey.CORRECT_SCORE_LIVE_H1
    ],
    layout: 'list',
    defaultExpanded: false
  },
  {
    id: 'handicap',
    title: 'Handicap',
    titleKey: 'sportsbook.sections.handicap',
    candidateBetTypeKeys: [BetTypeKey.HANDICAP, BetTypeKey.HANDICAP_H1, BetTypeKey.HANDICAP_H2, BetTypeKey.DNB],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'period-markets',
    title: 'Period Markets',
    titleKey: 'sportsbook.sections.periodMarkets',
    candidateBetTypeKeys: [
      BetTypeKey.PERIOD_WINNER,
      BetTypeKey.UNDER_OVER_PERIOD,
      BetTypeKey.XTH_GOAL_PERIOD,
      BetTypeKey.REST_OF_MATCH_PERIOD,
      BetTypeKey.HIGHEST_SCORE_PERIOD
    ],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'goal-markets',
    title: 'Goals',
    titleKey: 'sportsbook.sections.goals',
    candidateBetTypeKeys: [
      BetTypeKey.TOTAL_GOALS,
      BetTypeKey.TOTAL_GOALS_EXACT,
      BetTypeKey.TOTAL_GOALS_EXACT_H1,
      BetTypeKey.TOTAL_GOALS_EXACT_H2,
      BetTypeKey.GOAL_HOMETEAM,
      BetTypeKey.GOAL_AWAYTEAM,
      BetTypeKey.FIRST_GOAL_INT_15,
      BetTypeKey.LAST_GOAL,
      BetTypeKey.HIGHEST_SCORE_HALF,
      BetTypeKey.GNG_BOTH_HALVES_HOMETEAM,
      BetTypeKey.GNG_BOTH_HALVES_AWAYTEAM,
      BetTypeKey.XTH_GOAL_WAY3
    ],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'corners',
    title: 'Corners',
    titleKey: 'sportsbook.sections.corners',
    candidateBetTypeKeys: [
      BetTypeKey.UNDER_OVER_CORNER,
      BetTypeKey.UNDER_OVER_CORNER_HOMETEAM,
      BetTypeKey.UNDER_OVER_CORNER_AWAYTEAM,
      BetTypeKey.UNDER_OVER_CORNER_H1,
      BetTypeKey.CORNER_WAY3,
      BetTypeKey.CORNER_TOTAL
    ],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'half-time-full-time',
    title: 'Half Time / Full Time',
    titleKey: 'sportsbook.sections.halfTimeFullTime',
    candidateBetTypeKeys: [BetTypeKey.HT_FT],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'result-combos',
    title: 'Result Combos',
    titleKey: 'sportsbook.sections.resultCombos',
    candidateBetTypeKeys: [BetTypeKey.WAY_3_OR_WAY_3_H1, BetTypeKey.WAY_3_XUP],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'outright-winner',
    title: 'Outright Winner',
    titleKey: 'sportsbook.sections.outrightWinner',
    candidateBetTypeKeys: [BetTypeKey.OUTRIGHT_WINNER],
    layout: 'list',
    defaultExpanded: false
  },
  {
    id: 'misc-market-specials',
    title: 'Other',
    titleKey: 'sportsbook.sections.miscellaneous',
    candidateBetTypeKeys: [BetTypeKey.MULTISCORES, BetTypeKey.PLAYER_SENT_OFF, BetTypeKey.ANYTIME_GOALSCORER],
    layout: 'list',
    defaultExpanded: false
  },
  {
    id: 'first-half-match-result',
    title: '1st Half - Match Result',
    titleKey: 'sportsbook.sections.firstHalfMatchResult',
    candidateBetTypeKeys: [BetTypeKey.WAY_3_H1],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'first-half-total-goals',
    title: '1st Half - Total Goals (Over/Under)',
    titleKey: 'sportsbook.sections.firstHalfTotalGoals',
    candidateBetTypeKeys: [BetTypeKey.UNDER_OVER_H1],
    layout: 'grid2',
    defaultExpanded: false
  },
  {
    id: 'first-half-double-chance',
    title: '1st Half - Double Chance',
    titleKey: 'sportsbook.sections.firstHalfDoubleChance',
    candidateBetTypeKeys: [BetTypeKey.DOUBLE_CHANCE_H1],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'first-half-btts',
    title: '1st Half - Both Teams To Score',
    titleKey: 'sportsbook.sections.firstHalfBothTeamsToScore',
    candidateBetTypeKeys: [BetTypeKey.GOAL_NOGOAL_H1],
    layout: 'grid2',
    defaultExpanded: false
  },
  {
    id: 'second-half-match-result',
    title: '2nd Half - Match Result',
    titleKey: 'sportsbook.sections.secondHalfMatchResult',
    candidateBetTypeKeys: [BetTypeKey.WAY_3_H2],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'second-half-total-goals',
    title: '2nd Half - Total Goals (Over/Under)',
    titleKey: 'sportsbook.sections.secondHalfTotalGoals',
    candidateBetTypeKeys: [BetTypeKey.UNDER_OVER_H2],
    layout: 'grid2',
    defaultExpanded: false
  },
  {
    id: 'second-half-double-chance',
    title: '2nd Half - Double Chance',
    titleKey: 'sportsbook.sections.secondHalfDoubleChance',
    candidateBetTypeKeys: [BetTypeKey.DOUBLE_CHANCE_H2],
    layout: 'grid3',
    defaultExpanded: false
  },
  {
    id: 'second-half-btts',
    title: '2nd Half - Both Teams To Score',
    titleKey: 'sportsbook.sections.secondHalfBothTeamsToScore',
    candidateBetTypeKeys: [BetTypeKey.GOAL_NOGOAL_H2],
    layout: 'grid2',
    defaultExpanded: false
  }
];

const SPORTS_WITH_GROUPED_MATCH_DETAIL_MARKETS = new Set<Sport>([
  Sport.SOCCER,
  Sport.E_SOCCER,
  Sport.BASKETBALL,
  Sport.E_BASKETBALL,
  Sport.ICE_HOCKEY,
  Sport.HANDBALL,
  Sport.FOOTBALL,
  Sport.RUGBY
]);

export function shouldIncludeUnconfiguredMatchDetailBetTypes(sport: number): boolean {
  return !SPORTS_WITH_GROUPED_MATCH_DETAIL_MARKETS.has(sport);
}

export function getMatchDetailTabIdsForBetTypeKey(betTypeKey: BetTypeKey): readonly MatchDetailTabId[] {
  const tabIds = MATCH_DETAIL_TAB_DEFINITIONS
    .filter(definition => (definition.candidateBetTypeKeys as readonly BetTypeKey[]).includes(betTypeKey))
    .map(definition => definition.id);

  return tabIds.length ? tabIds : ['misc'];
}

export function getMatchDetailTabs(
  tabCounts: ReadonlyMap<MatchDetailTabId, number>,
  resolveLabel: MatchDetailTabsLabelResolver = definition => definition.label
): readonly MatchDetailTabViewModel[] {
  return MATCH_DETAIL_TAB_DEFINITIONS
    .map(definition => ({
      id: definition.id,
      label: resolveLabel(definition),
      count: tabCounts.get(definition.id) ?? 0
    }))
    .filter(tab => tab.count > 0);
}
